export function serializeValue(value: any): string {
  try {
    return JSON.stringify(value);
  } catch {
    return '{}';
  }
}

export function deserializeValue(rawValue: string): any {
  if (!rawValue) {
    return null;
  }
  try {
    return JSON.parse(rawValue);
  } catch {
    return null;
  }
}
